/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getSessionLengthAction } from "../actions/adminDashboardAction";

const initialState: any = {};

const subscribedUserSessions = createSlice({
  name: "Subscribed User Sessions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSessionLengthAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getSessionLengthAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getSessionLengthAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default subscribedUserSessions.reducer;
